import React from 'react';
import classnames from 'classnames';
import { Tag } from 'antd';

interface FilterTagProp {
	children: React.ReactNode;
	disabledButton?: boolean;
	reversed?: boolean;
	closable?: boolean;
	onClose?: () => void;
	onMouseDown?: (event: React.MouseEvent<HTMLSpanElement>) => void;
	disabled?: boolean;
}

export const FilterTag = ({
	children,
	disabledButton = false,
	disabled = false,
	reversed = false,
	closable = false,
	onClose,
	onMouseDown
}: FilterTagProp) => {
	const className = classnames('filter-bar-2-tag', {
		'filter-bar-2-tag-reversed': reversed,
		'filter-bar-2-tag-disabled-button': disabledButton,
		'filter-bar-2-tag-disabled': disabled
	});

	return (
		<Tag
			className={className}
			closable={closable}
			onClose={disabledButton ? undefined : onClose}
			onMouseDown={onMouseDown}
		>
			{children}
		</Tag>
	);
};
